import { I18n } from '@calendly/i18n'

import { isBlank } from 'services/string_utils'

/* TODO export limit from backend? */
const ACTIONS_COUNT_LIMIT = 5

export const MAX_SMS_BODY_LENGTH = 180

export const getVisibleActions = (actions) => (
  actions.filter(
    (action) => action._destroy !== true
  )
)

export const getActionTitle = (action) => (
  I18n.t(`publisher.workflows.actions.${action.configuration.type}.title`)
)

export const translateActionTitle = (title) => {
  if (title?.startsWith('workflows.actions.')) return I18n.t(`publisher.${title}.title`)

  return title
}


export const isValidConfiguration = (configuration, ownerType) => {
  switch (configuration.type) {
    case 'booking.email.event_to_invitee':
    case 'booking.email.event_to_someone_else':
    case 'booking.email.event_to_publisher':
      if (configuration.variant !== 'custom') return true
      if (isBlank(configuration.subject)) return false
      if (isBlank(configuration.body)) return false
      break
    case 'booking.sms.event_to_invitee':
      if (configuration.variant !== 'custom') return true
      if (isBlank(configuration.body)) return false
      break
    case 'booking.sms.event_to_publisher':
      if (!configuration.phone_number_uuid && ownerType === 'user') return false
      if (configuration.variant === 'custom') {
        if (isBlank(configuration.body)) return false
      }
      break
    default:
      break
  }
  return true
}

export const isActionsLimitReached = (count) => (
  count >= ACTIONS_COUNT_LIMIT
)

export const getActionsStatusMessage = (count) => (
  I18n.t('publisher.workflows.builder_form.actions_status', {
    count,
    limit: ACTIONS_COUNT_LIMIT
  })
)

export const isSmsAction = (type) => type.startsWith('booking.sms')
export const isToInvitee = (type) => !!type.match(/to_invitee$/)
